export const auth = {
  login: {
    title: 'Willkommen zurück',
    subtitle: 'Melde dich an, um fortzufahren',
    email: 'E-Mail-Adresse',
    emailPlaceholder: 'max@beispiel.com',
    password: 'Passwort',
    passwordPlaceholder: 'Dein Passwort',
    rememberMe: 'Angemeldet bleiben',
    forgotPassword: 'Passwort vergessen?',
    loginButton: 'Anmelden',
    signingIn: 'Anmeldung läuft...',
    orLoginWith: 'Oder anmelden mit',
    google: 'Google',
    apple: 'Apple',
    noAccount: 'Noch kein Konto?',
    registerNow: 'Jetzt registrieren',
    alreadyRegistered: 'Bereits registriert?',
    signIn: 'Anmelden',
    loginSuccess: 'Willkommen zurück!',
    otpSent: 'Bestätigungscode wurde an deine E-Mail gesendet.',
  },

  register: {
    title: 'Konto erstellen',
    subtitle: 'Starte deine Reise zu einem gesünderen Leben',
    formTitle: 'Registrierungsformular',
    fullName: 'Vollständiger Name',
    namePlaceholder: 'Max Mustermann',
    email: 'E-Mail-Adresse',
    emailPlaceholder: 'max@beispiel.com',
    password: 'Passwort',
    passwordPlaceholder: 'Mindestens 8 Zeichen',
    confirmPassword: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Passwort wiederholen',
    acceptTerms: 'Ich akzeptiere die',
    terms: 'Allgemeinen Geschäftsbedingungen',
    and: 'und die',
    privacy: 'Datenschutzerklärung',
    registerButton: 'Jetzt registrieren',
    creatingAccount: 'Konto wird erstellt...',
    haveAccount: 'Bereits ein Konto?',
    loginHere: 'Hier anmelden',
    alreadyRegistered: 'Bereits registriert?',
    selectedPlan: 'Ausgewählter Plan',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    yearlyDiscount: '-20%',
    yearlyDiscountText: '20% Rabatt bei jährlicher Zahlung',
    perMonth: 'pro Monat',
    perYear: 'pro Jahr',
    youSave: 'Du sparst {amount}',
    securityTitle: 'Sicher & Geschützt',
    securityText: 'Deine Daten sind bei uns sicher. Wir verwenden modernste Verschlüsselung und speichern keine Zahlungsinformationen.',
    referralBannerTitle: 'Du wurdest von einem Freund eingeladen!',
    referralBannerText: 'Du erhältst 10% Rabatt auf deinen ersten Monat beim Abonnieren.',
  },

  plans: {
    basic: {
      name: 'Basic Plan',
      features: [
        '1× vollständiger 30-Tage-Plan',
        'Einfache Mahlzeitbeschreibungen',
        'Kalorien & Zutaten pro Tag',
        'Berücksichtigt Allergien & Vorlieben',
        'Keine Änderungen möglich',
        'Keine detaillierten Rezepte',
        'Kein PDF-Export',
      ],
    },
    vip: {
      name: 'VIP Plan',
      features: [
        'Unbegrenzte 30-Tage-Pläne',
        'Jederzeit änderbar & anpassbar',
        'Detaillierte Schritt-für-Schritt-Rezepte',
        'Vollständige Einkaufs- & Rezeptliste',
        'PDF-Export für alle Pläne',
        'Dashboard mit Fortschritt',
        'Tägliche Motivations-E-Mails',
        '24/7 NutriBot Chat-Assistent',
      ],
    },
  },

  benefits: {
    secure: 'Sicher & Geschützt',
    access247: '24/7 Zugang',
    support: 'Support',
  },

  validation: {
    emailRequired: 'Bitte gib deine E-Mail-Adresse ein',
    emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
    passwordRequired: 'Bitte gib dein Passwort ein',
  },

  errors: {
    // Allgemein
    generic: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
    networkError: 'Netzwerkfehler. Bitte überprüfe deine Verbindung.',

    // Name
    nameRequired: 'Vollständiger Name ist erforderlich',
    nameTooShort: 'Name muss mindestens 2 Zeichen lang sein',

    // E-Mail
    emailRequired: 'E-Mail-Adresse ist erforderlich',
    emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
    emailAlreadyExists: 'Ein Konto mit dieser E-Mail-Adresse existiert bereits',

    // Passwort
    passwordRequired: 'Passwort ist erforderlich',
    passwordTooShort: 'Passwort muss mindestens 8 Zeichen lang sein',
    passwordWeak: 'Passwort muss mindestens einen Großbuchstaben und eine Zahl enthalten',
    passwordMismatch: 'Passwörter stimmen nicht überein',

    // AGB
    termsRequired: 'Du musst die Allgemeinen Geschäftsbedingungen akzeptieren',

    // Anmeldung
    invalidCredentials: 'Ungültige E-Mail-Adresse oder falsches Passwort',
    tooManyRequests: 'Zu viele Versuche. Bitte versuche es später erneut.',
    accountDisabled: 'Dieses Konto wurde deaktiviert. Bitte kontaktiere den Support.',

    // Gerät / OTP
    deviceFingerprintNotReady: 'Geräteidentifikation nicht bereit. Bitte versuche es erneut.',
    invalidOTPLink: 'Ungültiger Bestätigungslink. Bitte melde dich erneut an.',
    otpInvalid: 'Bitte gib einen gültigen 6-stelligen Code ein',
    otpIncorrect: 'Falscher Bestätigungscode. Bitte versuche es erneut.',
    otpExpired: 'Der Bestätigungscode ist abgelaufen. Bitte fordere einen neuen an.',
    otpMaxAttempts: 'Maximale Anzahl an Versuchen überschritten. Bitte fordere einen neuen Code an.',
    resendFailed: 'Code konnte nicht erneut gesendet werden. Bitte versuche es erneut.',

    // Passwort zurücksetzen
    invalidResetLink: 'Ungültiger Reset-Link',
    resetLinkExpired: 'Dieser Reset-Link ist abgelaufen. Bitte fordere einen neuen an.',
    resetLinkUsed: 'Dieser Reset-Link wurde bereits verwendet. Bitte fordere einen neuen an.',
    resetFailed: 'Passwort konnte nicht zurückgesetzt werden. Bitte versuche es erneut.',
    tooManyResetRequests: 'Zu viele Reset-Anfragen. Bitte versuche es in einigen Minuten erneut.',

    otpSendFailed: 'Konto erstellt, aber Bestätigungs-E-Mail konnte nicht gesendet werden. Bitte verwende die Option zum erneuten Senden.',
  },

  otp: {
    title: 'Gerät bestätigen',
    subtitle: 'Wir haben einen 6-stelligen Code gesendet an',
    verifyingDevice: 'Gerät wird überprüft',
    verifyButton: 'Gerät bestätigen',
    verifying: 'Wird bestätigt...',
    didntReceive: 'Keinen Code erhalten?',
    resendButton: 'Code erneut senden',
    resendIn: 'Erneut senden in {{seconds}}s',
    sending: 'Wird gesendet...',
    checkSpam: 'Überprüfe deinen Spam-Ordner, falls du die E-Mail nicht siehst',
    expiresIn: 'Der Code läuft in 5 Minuten ab',
    attemptsLeft: 'Noch {{count}} Versuche',
    oneAttemptLeft: 'Noch 1 Versuch',
    verificationSuccess: 'Gerät erfolgreich bestätigt.',
  },

  forgotPassword: {
    title: 'Passwort zurücksetzen',
    subtitle: 'Gib deine E-Mail-Adresse ein und wir senden dir einen Reset-Link',
    emailLabel: 'E-Mail-Adresse',
    emailPlaceholder: 'deine@email.com',
    submitButton: 'Reset-Link senden',
    sending: 'Wird gesendet...',
    backToLogin: 'Zurück zur Anmeldung',
    securityNote: 'Reset-Links laufen nach 1 Stunde ab und können nur einmal verwendet werden',
    checkEmail: 'E-Mail prüfen',
    successMessage: 'Wenn ein Konto mit dieser E-Mail-Adresse existiert, erhältst du in Kürze Anweisungen zum Zurücksetzen des Passworts.',
    didntReceive: 'Keine E-Mail erhalten?',
    hint1: 'Überprüfe deinen Spam- oder Junk-Ordner',
    hint2: 'Die E-Mail kann einige Minuten dauern',
    hint3: 'Stelle sicher, dass du die richtige E-Mail-Adresse eingegeben hast',
    tryDifferentEmail: 'Andere E-Mail-Adresse versuchen',
  },

  resetPassword: {
    title: 'Neues Passwort',
    subtitle: 'Erstelle ein sicheres Passwort für dein Konto',
    newPasswordLabel: 'Neues Passwort',
    newPasswordPlaceholder: 'Neues Passwort eingeben',
    confirmPasswordLabel: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Neues Passwort wiederholen',
    submitButton: 'Passwort zurücksetzen',
    resetting: 'Wird zurückgesetzt...',
    backToLogin: 'Zurück zur Anmeldung',
    validating: 'Reset-Link wird überprüft...',
    securityNote: 'Nach dem Zurücksetzen wirst du aus Sicherheitsgründen auf allen anderen Geräten abgemeldet',
    invalidToken: 'Link abgelaufen',
    invalidTokenMessage: 'Dieser Passwort-Reset-Link ist ungültig oder bereits abgelaufen.',
    requestNewLink: 'Neuen Link anfordern',
    reqLength: 'Mindestens 8 Zeichen',
    reqUppercase: 'Ein Großbuchstabe',
    reqNumber: 'Eine Zahl',
    reqMatch: 'Passwörter stimmen überein',
    strengthWeak: 'Schwach',
    strengthMedium: 'Mittel',
    strengthStrong: 'Stark',
  },

  passwordReset: {
    emailSent: 'Wenn ein Konto mit dieser E-Mail existiert, erhältst du in Kürze Anweisungen zum Zurücksetzen.',
    resetSuccess: 'Passwort erfolgreich zurückgesetzt. Du kannst dich jetzt mit deinem neuen Passwort anmelden.',
  },

  verifyEmail: {
    title: 'E-Mail bestätigen',
    subtitle: 'Wir haben einen 6-stelligen Bestätigungscode an gesendet',
    confirmButton: 'E-Mail bestätigen',
    expiresIn: 'Code läuft in 10 Minuten ab',
  },
};